import React from 'react';
import { useTranslation } from 'react-i18next';
import { Enterprise, Restaurant, Store, UserAvatar, UserFollow } from '@carbon/react/icons';
import { WIZARD_STEPS, WizardStep } from './wizardStep';

/**
 * Carbon's ProgressIndicator draws its own marker — CheckmarkOutline, Incomplete or
 * CircleDash — and exposes no way to substitute one, so a per-step glyph means owning
 * the list. The a11y wiring Carbon gave us for free is reproduced here deliberately.
 */
const STEP_ICONS: Record<Exclude<WizardStep, 'done'>, React.ComponentType<{ size?: number }>> = {
  profile: UserAvatar,
  organization: Enterprise,
  restaurant: Restaurant,
  branch: Store,
  invite: UserFollow,
};

const StepRail = ({ currentIndex }: { currentIndex: number }) => {
  const { t } = useTranslation('authentication');

  return (
    <ol className="onboarding-rail__list">
      {WIZARD_STEPS.map((name, index) => {
        const Icon = STEP_ICONS[name as Exclude<WizardStep, 'done'>];
        const state = index === currentIndex ? 'current' : index < currentIndex ? 'complete' : 'upcoming';

        return (
          <li
            key={name}
            data-testid={`onboarding-rail-step-${name}`}
            className={`onboarding-rail__step onboarding-rail__step--${state}`}
            aria-current={state === 'current' ? 'step' : undefined}
          >
            <span className="onboarding-rail__marker">
              {/* The glyph stays the step's own at every state; colour carries progress. */}
              <Icon size={20} data-step-icon={name} />
            </span>
            <span className="onboarding-rail__text">
              <span className="onboarding-rail__label">{t(`onboarding.steps.${name}`)}</span>
              <span className="onboarding-rail__description">{t(`onboarding.steps.${name}Description`)}</span>
            </span>
          </li>
        );
      })}
    </ol>
  );
};

export default StepRail;
